<template>
  <div>
        <!-- ADD ADDITIONAL PAYMENT START -->
    <CCol xs="12" md="12" lg="12" class="col-centered update-column">
      <h4 class="card-subtitle">Add additional payment for teacher</h4>
      <br>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <CCol md="12">
        <CRow>
          <CCol md="3">
            <strong>Teacher</strong>
          </CCol>
          <CCol md="9">
            <span><strong>: {{ teacher }} </strong></span>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="3">
            <strong>Email</strong>
          </CCol>
          <CCol md="9">
            <span>: {{ email }} </span>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="3">
            <strong>Phone Number</strong>
          </CCol>
          <CCol md="9">
            <span>: {{ phoneno }} </span>
          </CCol>
        </CRow>
        <br>
        <h6 class="card-subtitle">List of <code>additional payment</code></h6>
        <br>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Month Name</th>
                <th>Payment Info</th>
                <th>Payment Fee (RM)</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody style="background-color:white">
              <tr>
                <td>January 2019</td>
                <td>PAYMENT_FROM_TUITION</td>
                <td>0</td>
                <td>
                  <input type="submit" value="Remove" class="btn btn-danger pull-right">
                </td>
              </tr>                                             
              <tr>
                <td>
                  <select class="form-control">
                    <option>AUGUST 2018</option>
                    <option selected>SEPTEMBER 2018</option>
                    <option>OCTOBER 2018</option>
                    <option>NOVEMBER 2018</option>
                    <option>DECEMBER 2018</option>
                  </select>
                </td>
                <td>
                  <select class="form-control">
                    <option selected></option>
                    <option>KWSP (PEKERJA)</option>
                    <option>KWSP (MAJIKAN)</option>
                    <option>SOCSO (PEKERJA)</option>
                    <option>SOCSO (MAJIKAN)</option>
                  </select>
                </td>
                <td>
                  <input type="text" class="form-control">
                </td>
                <td>
                  <input type="submit" value="Add" class="btn btn-primary">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
      </CCol>
    </CCol>
    <!-- ADD ADDITIONAL PAYMENT END -->

    <br>

    <!-- SET PAYMENT START -->
    <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-subtitle">Learning Payment</h4>
      <br>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <CRow>
        <CCol md="4">
          <strong>Teacher Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ teacher }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Month Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ month }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Invoice</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ invoice }} </span>
        </CCol>
      </CRow>
      <br>
      <CRow>
        <CCol md="4">
          <strong>Payment Amount</strong>
        </CCol>
        <CCol md="8">
          <input type="number" value="0.00" step="any" class="form-control">
        </CCol>
      </CRow>
      
      <br>
      <hr>
      <input type="submit" value="Save Changes" class="btn btn-success" /> &nbsp;
      <input type="submit" value="View Receipt" class="btn btn-success" />
      <br>
    </CCol>
    <!-- SET PAYMENT END -->
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import jQuery from "jquery";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      teacher: "Beep-Beep",
      email: "office.akim@advancedcellnet.com",
      phoneno: "01020103041",
      month: "APRIL 2019",
      invoice: "RM 1592",
    //   desc: "June 2018",
    //   pname: "office.akim@advancedcellnet.com", 
    //   sname: "Super Cold And Hot Trial By Son Of Fuhrer The Great",
    //   invoice: "RM 1",
    //   discount: "RM 0",
    //   addpmt: "RM 29",
    //   finpmt: "RM 30",
    //   pmtamt: "RM 30",
    //   balexceed: "RM 0",
    //   finpmtdel: "RM 1",
    //   text: "Are you sure you want to delete this payment data?",
      months: [
        {
            id: "1",
            month: "AUGUST 2018",
        },
        {
            id: "2",
            month: "SEPTEMBER 2018",
        },
        {
            id: "3",
            month: "OCTOBER 2018",
        },
        {
            id: "4",
            month: "NOVEMBER 2018",
        },
        {
            id: "5",
            month: "DECEMBER 2018",
        },
      ]
    }
  },
}
</script>